<template>
  <div class="columns">
    <div class="column">
      <b-field
        :type="{ 'is-danger': errors.has(`${materialName}${pellIndex}mat`) }"
        :label="$translate(`${materialName}${pellIndex}mat`) | capitalize"
        :message="errors.first(`${materialName}${pellIndex}mat`)"
      >
        <b-select
          v-model="material"
          v-validate="isRequired ? 'required' : ''"
          :disabled="isDisabled"
          :name="`${materialName}${pellIndex}mat`"
          :placeholder="$translate('placeholder_select')"
        >
          <option
            v-for="pell in materialName === 'pell' ? availablepell : availablerip"
            :key="pell.id"
            :value="pell.id"
            :label="$translateMaterial(pell)"
          >
            {{ $translateMaterial(pell) }}
          </option>
        </b-select>
      </b-field>
      <b-field
        v-show="material != null"
        :message="errors.first(`${materialName}${pellIndex}var`)"
        :type="{ 'is-danger': errors.has(`${materialName}${pellIndex}var`) }"
        :label="$translate(`${materialName}${pellIndex}var`) | capitalize"
      >
        <b-select
          v-model="variant"
          v-validate="isRequired || !!material ? 'required' : ''"
          :disabled="isDisabled"
          :name="`${materialName}${pellIndex}var`"
          :placeholder="$translate('placeholder_select')"
        >
          <template v-for="pell in materialName === 'pell' ? availablepell : availablerip">
            <template v-if="pell.id === material">
              <option v-for="pellVar in pell.variants" :key="pellVar.id" :value="pellVar.id">
                {{ $translateMaterialVariant(pellVar) }}
              </option>
            </template>
          </template>
        </b-select>
      </b-field>
      <b-field
        v-if="material != null && hasAllestimento"
        :type="{ 'is-danger': errors.has(`${materialName}${pellIndex}allestimento`) }"
        :label="$translate(`${materialName}${pellIndex}allestimento`) | capitalize"
        :message="errors.first(`${materialName}${pellIndex}allestimento`)"
      >
        <b-select
          v-model="allestimento"
          v-validate="isRequired"
          :disabled="isDisabled"
          :name="`${materialName}${pellIndex}allestimento`"
          :placeholder="$translate('placeholder_select')"
        >
          <option v-for="a in availableallestimenti" :key="a.id" :value="a.id">
            {{ a.name }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column">
      <img :src="imageSrc" style="max-width: 150px; max-height: 150px;" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'tomaio-repeater',
  props: {
    availablepell: {
      type: Array,
    },
    availablerip: {
      type: Array,
    },
    availableallestimenti: {
      type: Array,
    },
    pellmat: {
      type: String,
    },
    pellvar: {
      type: Number,
    },
    pellallestimento: {
      type: String,
    },
    image: {
      type: String,
    },
    pellIndex: {
      type: Number,
    },
    isDisabled: {
      type: Boolean,
    },
    isRequired: {
      type: Boolean,
    },
    materialName: {
      type: String,
    },
    hasAllestimento: {
      type: Boolean,
      default: false,
    },
    orderbool: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['$validator'],
  computed: {
    material: {
      get() {
        return this.pellmat
      },
      set(val) {
        this.$emit('changePell', val, this.pellIndex)
      },
    },
    variant: {
      get() {
        return this.pellvar
      },
      set(val) {
        this.$emit('changeImage', val, this.pellIndex)
      },
    },
    allestimento: {
      get() {
        return this.pellallestimento
      },
      set(val) {
        this.$emit('changeAllestimento', val, this.pellIndex, this.materialName === 'pell' ? 'Pel_M' : 'Rip_M')
      },
    },
    imageSrc() {
      if (this.image) return this.image
      if (this.materialName === 'pell') {
        for (let index in this.availablepell) {
          if (this.availablepell[index].id === this.material) {
            for (let index2 in this.availablepell[index].variants) {
              if (this.availablepell[index].variants[index2].id === this.variant) {
                return this.availablepell[index].variants[index2].image
              }
            }
          }
        }
      }
      if (this.materialName === 'rip') {
        for (let index in this.availablerip) {
          if (this.availablerip[index].id === this.material) {
            for (let index2 in this.availablerip[index].variants) {
              if (this.availablerip[index].variants[index2].id === this.variant) {
                return this.availablerip[index].variants[index2].image
              }
            }
          }
        }
      }

      return 'https://place-hold.it/150x150'
    },
  },
}
</script>

<style scoped></style>
